import { TextProps } from '@features/powerpoint';

export const chartTitleText = (
  title: string,
  units: string,
  color: string,
  hideUnits = false
): TextProps['text'] => [
  {
    text: title.toUpperCase(),
    options: {
      color,
    },
  },
  {
    text: hideUnits ? '' : ` (${units.toUpperCase()})`,
  },
];
